// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"60":"0be7f202f0","253":"18267c176f","619":"4c7d5377e7"}[chunkId] + ".js";
};